export const types = {
  verify_account: "[Verify]",
  config_contact: "[Configuration Contact Center]",
  config_attentions: "[Configuration Attentions]",
  config_roles: "[Configuration Roles]",
  config_lang: "[COnfiguration Lang]",
};
